import { render, staticRenderFns } from "./addNewMedia.vue?vue&type=template&id=10ded5be&"
import script from "./addNewMedia.vue?vue&type=script&lang=js&"
export * from "./addNewMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports